import { render, staticRenderFns } from "./autoTranslateReaction.vue?vue&type=template&id=44c81bc5&scoped=true"
import script from "./autoTranslateReaction.vue?vue&type=script&lang=js"
export * from "./autoTranslateReaction.vue?vue&type=script&lang=js"
import style0 from "./autoTranslateReaction.vue?vue&type=style&index=0&id=44c81bc5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44c81bc5",
  null
  
)

export default component.exports